<template>
  <v-layout
    id="print-form-dealer"
    row
    justify-center
    align-center
    class="layout">
    <v-col cols="12" md="8">
      <v-row>
        <v-col cols="12" class="row section-box pa-0">
          <v-col class="pa-0 banner" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="row section-box pa-0">
          <div class="header-line" />
          <v-col>
            <div class="pa-2">
              <p class="header">
                ใบสมัครตัวแทน Secret Me Thailand
              </p>
              <p>โปรดกรอกข้อมูลให้ครบถ้วน และ ถูกต้อง เพื่อความรวดเร็วในการจัดทำบัตรตัวแทนต่อไป</p>
              <p>โปรดจัดเตรียมไฟล์รูปภาพ Jpeg สำหรับเอกสารแนบการสมัครตัวแทนเพื่อ upload ลงใบสมัครนี้</p>
              <p class="require-text">
                * จำเป็น
              </p>
            </div>
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col cols="12" sm="6" class="card">
            <div>
              ชื่อ <span class="require-text"> * </span>
            </div>
            <v-text-field
              :value="dealer.firstName"
              readonly
            />
          </v-col>
          <v-col cols="12" sm="6">
            <div>
              นามสกุล <span class="require-text"> * </span>
            </div>
            <v-text-field
              :value="dealer.lastName"
              readonly
            />
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col cols="12" sm="6" class="card">
            <div>
              ชื่อเล่น <span class="require-text"> * </span>
            </div>
            <v-text-field
              :value="dealer.nickName"
              readonly
            />
          </v-col>
          <v-col cols="12" sm="6">
            <div>
              วันเกิด <span class="require-text"> * </span>
            </div>
            <v-text-field
              :value="localDay(dealer.dob)"
              readonly
            />
          </v-col>
        </v-col>
      </v-row>
      <div class="page-break"></div>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div>
              อีเมล <span class="require-text"> * </span>
            </div>
            <v-text-field
              :value="dealer.email"
              readonly
            />
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div>
              เพศ <span class="require-text"> * </span>
            </div>
            <v-radio-group readonly v-model="dealer.gender">
              <v-radio
                v-for="gender in genders"
                :key="gender"
                :label="gender"
                :value="gender"
              />
            </v-radio-group>
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div>
              รหัสตัวแทนเดิม (กรณีเป็นตัวแทนอยู่แล้ว)
            </div>
            <v-text-field
              :value="dealer.oldDealerId"
              readonly
            />
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div>
              รหัสตัวแทนแม่ทีม (ตัวแทนที่ท่านสมัครด้วย) <span class="require-text"> * </span>
            </div>
            <v-text-field
              :value="dealer.teamParentId"
              readonly
            />
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div>
              สายทีม <span class="require-text"> * </span>
            </div>
            <v-text-field
              :value="dealer.classTeam"
              readonly
            />
          </v-col>
        </v-col>
      </v-row>
      <div class="page-break"></div>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div>
              สถานะ <span class="require-text"> * </span>
            </div>
            <v-radio-group :value="dealer.sellerStatus" readonly>
              <v-radio
                v-for="st in status"
                :key="st"
                :label="st"
                :value="st"
              />
            </v-radio-group>
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div>
              ที่อยู่ที่สามารถติดต่อได้สะดวก <span class="require-text"> * </span>
            </div>
            <v-textarea
              :value="dealer.address"
              readonly
            />
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div>
              จังหวัด <span class="require-text"> * </span>
            </div>
            <v-text-field
              :value="dealer.province"
              readonlys
            />
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div>
              รหัสไปรษณีย์ <span class="require-text"> * </span>
            </div>
            <v-text-field
              :value="dealer.postCode"
              readonly
            />
          </v-col>
        </v-col>
      </v-row>
      <div class="page-break"></div>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div>
              เบอร์โทรศัพท์ที่ติดต่อได้สะดวก <span class="require-text"> * </span>
            </div>
            <v-text-field
              :value="dealer.tel"
              readonly
            />
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div>
              LINE ID (ถ้ามี)
            </div>
            <v-text-field :value="dealer.lineId" readonly />
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div>
              Instagram (ถ้ามี)
            </div>
            <v-text-field :value="dealer.instagram" readonly />
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div>
              Facebook <span class="require-text"> * </span>
            </div>
            <v-text-field
              :value="dealer.facebook"
              readonly
            />
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div>
              TikTok
            </div>
            <v-text-field
              :value="dealer.tiktok"
              readonly
            />
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div>
              Facebook Fanpage (ถ้ามี)
            </div>
            <v-text-field :value="dealer.facebookPage" readonly />
          </v-col>
        </v-col>
      </v-row>
      <div class="page-break"></div>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div>
              พื้นที่ขาย <span class="require-text"> * </span>
            </div>
            <v-text-field
              :value="dealer.sellArea"
              readonly
            />
          </v-col>
        </v-col>
      </v-row>
      <div class="page-break"></div>
      <v-row>
        <v-col cols="12" class="row section-box pa-0">
          <div class="header-line-text">
            รายละเอียดสัญญาการสมัครตัวแทนจำหน่าย Secret Me Thailand
          </div>
          <v-col class="">
            <div class="pa-2" style="font-size: 12px">
              <p>
                1. บริษัท ซีเครท มี จำกัด อนุญาตให้ตัวแทนทุกท่าน สามารถจำหน่ายสินค้าผ่านแอปพลิเคชั่น Shopee / Lazada และ แอปพลิเคชั่นช็อปปิ้งออนไลน์ต่างๆ ได้ แต่จะต้องจำหน่ายสินค้าในราคาที่หักส่วนลดต่างๆของแอปพลิเคชั่นนั้นๆแล้ว  ราคาขายสุทธิที่ลูกค้าทำการชำระเงินนั้นจะต้องไม่ต่ำกว่าราคาที่บริษัทฯ กำหนด ( เว้นแต่ลูกค้าจะใช้สิทธิ์ส่วนลดเหรียญหรือแต้มสะสมต่างๆ และสิทธิ์ของบัตรเครดิตที่เป็นสิทธิ์เฉพาะของลูกค้าเท่านั้น ) และการขายในแอปพลิชั่น Shopee / Lazada หรือแอปพลิเคชั่นช็อปปิ้งออนไลน์ต่างๆนั้น จะต้องไม่ขัดกับกฎข้อบังคับอื่นๆ ตามเอกสารแห่งสัญญาฉบับนี้ มิเช่นนั้นจะถือว่าท่านได้กระทำผิดสัญญาข้อตกลงระหว่างตัวแทนจำหน่าย กับ บริษัท ซีเครท มี จำกัด
                <br> <br>
                2. บริษัท ซีเครท มี จำกัด ไม่อนุญาตให้จำหน่ายสินค้าต่ำกว่าราคาที่ทางบริษัทฯกำหนด
                <br> <br>
                3. บริษัท ซีเครท มี จำกัด ไม่อนุญาตให้จัดโปรโมชั่นหรือของแถม ก่อนได้รับอนุญาตจากทางบริษัทฯ
                <br> <br>
                4. ตัวแทนทุกท่าน ยินยอมให้ทางบริษัท ซีเครท มี ตรวจสอบรายละเอียดภายในทีม หรือข้อมูลอื่นๆได้ทุกประการ
                <br> <br>
                5. ในกรณีที่รหัสสินค้าที่ตัวแทนได้รับไป ตกอยู่กับผู้ใดผู้หนึ่ง และผู้นั้นได้ทำการละเมิดข้อตกลงดังกล่าวข้างต้น ตัวแทนจะต้องทำการรับผิดชอบค่าเสียหายที่เกิดขึ้น โดยมิอาจหลีกเลี่ยง หรือกล่าวอ้างบุคคลใดบุคคลหนึ่งเพื่อให้ตนพ้นผิด แม้บุคคลนั้นจะไม่ได้เป็นตัวแทนที่ทางบริษัทฯ แต่งตั้งก็ตาม
                <br> <br>
                6. ในกรณีที่ถูกยกเลิก หรือตัดสิทธิ์การเป็นตัวแทนจำหน่ายแล้ว ไม่สามารถคืนสินค้าและไม่สามารถนำสินค้าที่มีอยู่มาขายต่ำกว่าที่บริษัทฯกำหนดได้
                <br> <br>
                7. ข้าพเจ้าตกลงยอมรับเงื่อนไข และข้อปฏิบัติของทาง  บริษัท ซีเครท มี จำกัด ทุกข้อตกลง โดยปราศจากข้อสงสัยใดๆ และยอมรับผิดทุกประการ หากข้าพเจ้าฝ่าฝืนข้อตกลงที่ทางบริษัท ซีเครท มี จำกัด กำหนดจะยินยอมให้ทาง บริษัท ซีเครท มี จำกัด ตัดสิทธิ์หรือยกเลิกการเป็นตัวแทนจำหน่าย รวมถึงสิทธิประโยชน์ทั้งหมดที่มี และข้าพเจ้ายินยอมชดใช้ค่าเสียหายทั้งปวงให้แก่ บริษัท ซีเครท มี จำกัด เป็นจำนวนเงิน   ***200,000 บาท   (***สองแสนบาทถ้วน)   หรือ คิดเป็นอัตราร้อยละ 20 ตามจำนวนทั้งหมดของสินค้านั้นๆ ในรอบบิลที่เกิดความเสียหายขึ้น (โดยเอายอดที่มากกว่าเป็นเกณฑ์) ภายใน 15 วัน นับตั้งแต่วันที่บริษัท ซีเครท มี ได้ทราบถึงเหตุละเมิดนั้น (โดยไม่รวมกับค่าเสียหายอื่นๆ ที่เกิดจากการเสียโอกาสทางการขายของตัวแทนท่านอื่นๆ)
                <br> <br>
                หากเกินกำหนด 15 วัน ตัวแทนที่ทำการละเมิดนั้น ไม่ชดใช้ค่าเสียหายดั่งที่ได้กล่าวมาตามวรรคก่อนให้แก่บริษัท ซีเครท มี จำกัด ทาง บริษัท ซีเครท มี จะดำเนินคดีตามกฎหมายเป็นขั้นตอนต่อไปถึงที่สุด โดยจะเรียกค่าเสียหายตามเหตุละเมิดแห่งสัญญาฉบับนี้ พร้อมทั้งดอกเบี้ย ร้อยละ 7.5 ต่อปี จนถึงคดีสิ้นสุด
              </p>
            </div>
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div>
              โปรดอ่านให้เข้าใจก่อนตอบคำถาม เพราะสัญญาฉบับนี้ จะบังคับใช้ทางกฎหมายต่อไป <span class="require-text"> * </span>
            </div>
            <v-checkbox
              :value="dealer.accepted"
              readonly
              :label="`ข้าพเจ้ายินยอมตกลงรับเงื่อนไขของ บริษัท ซีเครท มี จำกัด ทุกประการ`"
            />
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="row section-box pa-0">
          <div class="header-line-text">
            โปรดแนบเอกสารการสมัครตัวแทนจำหน่าย
          </div>
          <v-col class="">
            <div class="pa-2">
              <ul>
                <li>
                  เอกสารสำหรับการสมัครตัวแทนจำหน่าย กรุณาส่งด้วยไฟล์รูปภาพ เท่านั้น ขนาดไม่เกิน 10MB
                </li>
                <li>
                  รูปถ่ายขอเป็นรูปที่เห็นหน้าชัดเจน และสวยที่สุด ยิ้มแย้มเห็นฟันได้ แต่ไม่อนุญาตให้สวมแว่นดำ หรือหมวก
                </li>
                <li>
                  หากส่งเอกสารผิดทาง บริษัท ซีเครท มี ขอสงวนสิทธิ์ที่จะจัดทำบัตรตัวแทนให้ หรืออาจจะทำบัตรตัวแทนได้ล่าช้ากว่าที่กำหนด
                </li>
              </ul>
            </div>
          </v-col>
        </v-col>
      </v-row>
      <div class="page-break"></div>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div class="mb-4">
              สำเนาบัตรประชาชน เซ็นสำเนาถูกต้อง (ต้องลงลายมือชื่อด้วยปากกาเท่านั้น ห้ามใช้ app ในการใส่ชื่อ) <span class="require-text"> * </span>
            </div>
            <div>
              <img
                :src="dealer.nationalCardImageUrl"
                alt="national-id"
                style="width: 100%"
                @error="imgCheck('nationalCard')"
                v-if="hasNationalCartImg">
                <div v-else>
                  <a :href="dealer.nationalCardImageUrl" target="_blank">The image</a> could not be loaded.
                </div>
            </div>
          </v-col>
        </v-col>
      </v-row>
      <div class="page-break"></div>
      <v-row>
        <v-col cols="12" class="row section-box">
          <v-col>
            <div class="mb-4">
              รูปถ่ายสำหรับทำบัตรตัวแทน <span class="require-text"> * </span>
            </div>
            <div>
              <img
                :src="dealer.sellerCardImageUrl"
                alt="national-id"
                style="width: 100%"
                @error="imgCheck('seller')"
                v-if="hasSellerImg">
              <div v-else>
                <a :href="dealer.sellerCardImageUrl" target="_blank">The image</a> could not be loaded.
              </div>
            </div>
          </v-col>
        </v-col>
      </v-row>
    </v-col>
  </v-layout>
</template>

<script>
import DealerProvider from '@/resources/DealerProvider'
import { mapActions } from 'vuex'
import dayjs from 'dayjs'
const dealerService = new DealerProvider()
export default {
  data: () => ({
    loading: false,
    hasSellerImg: true,
    hasNationalCartImg: true,
    dealer: {},
    genders: [
      'ชาย', 'หญิง', 'ไม่ระบุ'
    ],
    status: [
      'ตัวแทน Exclusive', 'ตัวแทน VIP', 'ตัวแทนเดิม Stock', 'ตัวแทนเดิม Non-Stock', 'ตัวแทนใหม่ Stock', 'ตัวแทนใหม่ Non-Stock'
    ]
  }),
  computed: {
    dealerId () {
      return this.$route.params.id ? this.$route.params.id : 0
    }
  },
  async mounted () {
    this.loading = true
    await this.getDealer()
    await this.delay(1500)
    window.print()
    this.loading = false
  },
  methods: {
    delay(timeout) {
      return new Promise((resolve) => {
        setTimeout(resolve, timeout)
      })
    },
    imgCheck (type) {
      if (type === 'seller') {
        this.hasSellerImg = false
      } else {
        this.hasNationalCartImg = false
      }
    },
    ...mapActions({
      setSnackbar: 'Style/setSnackbar'
    }),
    localDate (date) {
      if (date === null || date === '' || date === undefined) {
        return '-'
      }
      return dayjs(date).format('DD-MM-YYYY HH:mm')
    },
    localDay (date) {
      if (date === null || date === '' || date === undefined) {
        return '-'
      }
      return dayjs(date).format('DD-MM-YYYY')
    },
    async getDealer () {
      try {
        const { data } = await dealerService.getDealerById(this.dealerId)
        this.dealer = data
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          active: true
        })
      }
    }
  }
}
</script>

<style lang="css" scoped>

.layout {
  padding: 20px 20px 20px 40px;
  background-color: #e9e3d4 !important;
}
.section-box {
  border: 1px solid #dadce0;
  border-radius: 8px;
  background-color: #fff;
  margin-bottom: 12px;
}
.banner {
  height: 150px;
  border-radius: 8px;
  background-image: url('~@/assets/banner.jpg');
  background-size: cover;
  background-position: center;
}
@media all {
  .page-break {
    display: none;
  }
}

@media print {
  .page-break {
    display: block;
    page-break-before: always;
    padding-top: 20px;
  }
}
.header {
  font-size: 32px;
  font-weight: 400;
}
.require-text {
  color: #d93025;
}
.header-line {
  background-color: rgb(191, 174, 134);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  height: 10px;
  width: calc(100% + 2px);
}
.header-line-text {
  background-color: rgb(191, 174, 134);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  padding: 16px;
  width: calc(100% + 2px);
}
</style>
